import React from 'react';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';

const CustomerMetricsChart = ({ data }) => {
  if (!data || !data.total_users || data.total_users === 0) {
    return (
      <div className="chart-widget" style={{ background: 'white', padding: '16px', borderRadius: '8px', width: '100%', boxSizing: 'border-box', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
        <h3 style={{ fontSize: '14px', fontWeight: '700', margin: '0 0 12px 0', color: '#1a1a1a' }}>Customer Analytics</h3>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '160px', color: '#6b7280' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '28px', marginBottom: '8px' }}>👥</div>
            <p style={{ fontSize: '12px', margin: 0 }}>No customer data available</p>
          </div>
        </div>
      </div>
    );
  }

  const active = data.active_users || 0;
  const inactive = (data.total_users || 0) - active;

  const chartData = [
    { name: 'Active', value: active, color: '#10b981' },
    { name: 'Inactive', value: inactive, color: '#6b7280' },
  ];

  // Fixed pixel size — no ResponsiveContainer needed for a centered donut
  const SIZE = 160;

  return (
    <div className="chart-widget" style={{ background: 'white', padding: '16px', borderRadius: '8px', width: '100%', boxSizing: 'border-box', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
      <h3 style={{ fontSize: '14px', fontWeight: '700', margin: '0 0 12px 0', color: '#1a1a1a' }}>Customer Analytics</h3>

      {/* Centered donut with fixed pixel width/height — no ResponsiveContainer */}
      <div style={{ display: 'flex', justifyContent: 'center', position: 'relative', height: SIZE }}>
        <PieChart width={SIZE} height={SIZE}>
          <Pie
            data={chartData}
            cx={SIZE / 2}
            cy={SIZE / 2}
            innerRadius={45}
            outerRadius={68}
            paddingAngle={2}
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip
            formatter={(value) => [value, 'Users']}
            contentStyle={{ backgroundColor: 'white', border: '1px solid #e5e7eb', borderRadius: '6px', fontSize: '12px' }}
          />
        </PieChart>
        {/* Center label */}
        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center', pointerEvents: 'none' }}>
          <div style={{ fontSize: '22px', fontWeight: '700', color: '#1f2937', lineHeight: 1 }}>{data.total_users}</div>
          <div style={{ fontSize: '10px', color: '#6b7280' }}>Total</div>
        </div>
      </div>

      <div style={{ textAlign: 'center', marginTop: '10px', fontSize: '12px' }}>
        <span style={{ color: '#10b981', fontWeight: '600' }}>Active: {active}</span>
        <span style={{ margin: '0 8px', color: '#d1d5db' }}>|</span>
        <span style={{ color: '#6b7280', fontWeight: '600' }}>Inactive: {inactive}</span>
        <div style={{ color: '#374151', fontSize: '11px', marginTop: '4px' }}>Total Users: {data.total_users}</div>

        {data.logged_in_count !== undefined && (
          <div style={{ marginTop: '8px', paddingTop: '8px', borderTop: '1px solid #f3f4f6', display: 'flex', justifyContent: 'center', gap: '16px' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ color: '#10b981', fontSize: '14px', fontWeight: '700' }}>{data.logged_in_count}</div>
              <div style={{ color: '#6b7280', fontSize: '10px' }}>Logged In</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ color: '#9ca3af', fontSize: '14px', fontWeight: '700' }}>{data.logged_out_count}</div>
              <div style={{ color: '#6b7280', fontSize: '10px' }}>Logged Out</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerMetricsChart;
